export const PRISMIC_API_URL = 'https://alliance-consumer-growth.cdn.prismic.io/api/v2'